function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, useState, useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import sharedCss from "./sharedCss";
import { InternalUseOnlyInput } from "./Input";
import { white, spacing4 } from "@churchofjesuschrist/eden-style-constants";
import { ValidityStateContext } from "./validityState";
export const InternalUseOnlyInputGroup = styled.div.withConfig({
  componentId: "sc-cajwz5-0"
})(["position:relative;display:flex;align-items:center;width:100%;background-color:", ";&::after{content:\"\";", ";position:absolute;pointer-events:none;background:none;height:auto;top:0;left:0;right:0;bottom:0;}& > ", ",& > ", ":focus,& > &::after,& div ::after{border:0;box-shadow:none;}&& > *{margin:", ";}& > &,& > ", "{margin:0;}"], white, sharedCss, InternalUseOnlyInput, InternalUseOnlyInput, _ref => {
  let {
    small
  } = _ref;
  return small ? "0" : spacing4;
}, InternalUseOnlyInput);

/**
 * The InputGroup combines an Input with an Icon/Button component.
 */
const InputGroup = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    children,
    validityState,
    small,
    ...props
  } = _ref2;
  const validityStateContext = useContext(ValidityStateContext);
  const [focus, setFocus] = useState(false);
  const focusHandler = event => {
    if (event.target.tagName.toLowerCase() === "input") {
      setFocus(true);
    }
  };
  const blurHandler = event => {
    if (event.target.tagName.toLowerCase() === "input") {
      setFocus(false);
    }
  };
  return /*#__PURE__*/React.createElement(InternalUseOnlyInputGroup, _extends({
    validityState: validityState ? validityState : validityStateContext,
    focus: focus,
    onFocus: focusHandler,
    onBlur: blurHandler,
    small: small,
    ref: ref
  }, props), /*#__PURE__*/React.createElement(ValidityStateContext.Provider, {
    value: validityState ? validityState : validityStateContext
  }, children));
});
InputGroup.displayName = "InputGroup";
InputGroup.propTypes = {
  /** The current validity state of the InputGroup */
  validityState: PropTypes.oneOf(["error", "warning", "success", "unknown"]),
  /** A boolean indicating if the InputGroup should be rendered in a smaller height */
  small: PropTypes.bool,
  /** Content to render inside the InputGroup Component. Children should contain some type of `input` or `select` element and an `icon` or `button` element.  */
  children: PropTypes.node.isRequired
};
export default InputGroup;